import { type PlanDuration } from '@vy/types';
import React from 'react';
import { type Control, FieldPath } from 'react-hook-form';
import { getPlanDurationValues } from '../../utils/get-plan-duration-values';
import { PlanSettingsAutoCompleteField } from './PlanSettingsAutoCompleteField';
import { PlanSettingsInputForm } from './CreatePlanForm/create-plan-form-types/plan-settings-input-form';

type PlanDurationAutoCompleteProps = {
  className?: string;
  defaultValue?: PlanDuration;
  disabled?: boolean;
  control: Control<PlanSettingsInputForm>;
  name: FieldPath<PlanSettingsInputForm>;
  currentValue?: number;
};

export const PlanDurationAutoComplete: React.FC<PlanDurationAutoCompleteProps> = ({
  className,
  control,
  name,
  defaultValue,
  disabled = false,
  currentValue,
}) => {
  const values = getPlanDurationValues(currentValue);
  const defaultValueAsItem = values.find(({ value }) => value === defaultValue);

  return (
    <PlanSettingsAutoCompleteField
      control={control}
      name={name}
      className={className}
      values={values}
      disabled={disabled}
      label="Plan duration"
      defaultItem={defaultValueAsItem}
      mapValueChange={(inputNumber) => inputNumber}
    />
  );
};
